import styled, { createGlobalStyle } from 'styled-components';
import { Form, Button, Modal } from 'antd';
import { Box, Flex, Text } from 'atoms';

export const GlobalSelectStyle = createGlobalStyle`
	.ant-select-dropdown {
		z-index: 9999 !important;
		
		.ant-select-item {
			padding: 8px 12px !important;
			color: #1e293b !important;
			font-size: 14px !important;
		}
		
		.ant-select-item-option-content {
			color: #1e293b !important;
		}
		
		.ant-select-item-option-selected {
			background-color: #e0e7ff !important;
			font-weight: 500 !important;
		}
		
		.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
			background-color: #f3f4f6 !important;
		}
	}
`;

export const StyledForm = styled(Form)`
	.ant-form-item-label > label {
		font-weight: 500;
		font-size: 14px;
		color: #1e293b;

		&.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
			&::before {
				display: none !important;
			}

			&::after {
				display: inline-block;
				margin-left: 4px;
				color: #000000;
				font-size: 14px;
				font-family: SimSun, sans-serif;
				line-height: 1;
				content: '*';
			}
		}
	}
	.ant-form-item {
		margin-bottom: 24px;
	}

	.ant-input,
	.ant-select-selector,
	.ant-input-textarea {
		border-radius: 6px;
		border: 1px solid #e2e8f0;
		font-size: 14px;

		&:hover {
			border-color: #94a3b8;
		}

		&:focus,
		&.ant-input-focused,
		&.ant-select-focused .ant-select-selector {
			border-color: #3b82f6;
			box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
		}
	}

	.ant-select-selector {
		height: 40px !important;
		padding: 4px 11px !important;
		display: flex;
		align-items: center;
	}

	.ant-input {
		height: 40px;
		padding: 8px 12px;
	}

	.ant-input-textarea {
		padding: 8px 12px;
	}
`;

export const PageHeader = styled(Flex)`
	margin-bottom: 24px;
	align-items: center;
	gap: 12px;
`;

export const BackButton = styled(Box)`
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 8px;
	border-radius: 6px;
	transition: background-color 0.2s;

	&:hover {
		background-color: #f1f5f9;
	}
`;

export const PageTitle = styled(Text)`
	font-size: 24px;
	font-weight: 600;
	color: #0f172a;
	line-height: 1.2;
`;

export const PageSubtitle = styled(Text)`
	font-size: 14px;
	color: #64748b;
	margin-top: 4px;
`;

export const TransferButton = styled(Button)`
	background-color: #e0f2fe;
	border: 1px solid #0ea5e9;
	color: #0369a1;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #bae6fd !important;
		border-color: #0284c7 !important;
		color: #0369a1 !important;
	}
`;

export const EditButton = styled(Button)`
	background-color: #1e40af;
	border-color: #1e40af;
	color: white;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	border-radius: 6px;

	&:hover {
		background-color: #1e3a8a !important;
		border-color: #1e3a8a !important;
		color: white !important;
	}
`;

export const PageContainer = styled(Box)`
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
`;

export const ContentWrapper = styled(Box)`
	max-width: 1400px;
	margin: 0 auto;
`;

export const FormSection = styled(Box)`
	background: white;
	padding: 32px;
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	margin-bottom: 20px;
	border: 1px solid #e5e7eb;
`;

export const AddButton = styled(Button)`
	background-color: #18405d;
	border-color: #18405d;
	height: 36px;
	padding: 0 24px;
	font-weight: 500;
	color: white;

	&:hover {
		background-color: #1a4a6d !important;
		border-color: #1a4a6d !important;
		color: white !important;
	}
`;

export const CancelButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	border: 1px solid #d1d5db;
	color: #374151;
	background: white;
	border-radius: 6px;

	&:hover {
		border-color: #9ca3af !important;
		color: #1f2937 !important;
		background: #f9fafb !important;
	}
`;

export const SubmitButton = styled(Button)`
	background-color: #18405d;
	border-color: #18405d;
	height: 40px;
	padding: 0 32px;
	font-weight: 500;
	font-size: 14px;
	color: white;
	border-radius: 6px;

	&:hover {
		background-color: #1a4a6d !important;
		border-color: #1a4a6d !important;
		color: white !important;
	}

	&:disabled {
		background-color: #94a3b8;
		border-color: #94a3b8;
	}
`;

export const BulkUploadButton = styled(Button)`
	height: 40px;
	padding: 0 20px;
	font-weight: 500;
	border: 1px solid #d1d5db;
	color: #374151;
	background: white;
	border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		border-color: #9ca3af !important;
		color: #1f2937 !important;
		background: #f9fafb !important;
	}

	.anticon {
		font-size: 16px;
	}
`;

export const TableWrapper = styled(Box)`
	background: white;
	padding: 16px;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	margin-bottom: 16px;

	.ant-table {
		font-size: 13px;
	}

	.ant-table-thead > tr > th {
		padding: 10px 8px;
		font-size: 13px;
		background-color: #18405d !important;
		color: white !important;
	}

	.ant-table-tbody > tr > td {
		padding: 8px;
	}
`;

export const StyledModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 8px;
	}

	.ant-modal-header {
		border-bottom: none;
		padding: 20px 24px;
	}

	.ant-modal-title {
		font-size: 18px;
		font-weight: 600;
		color: #1e293b;
	}

	.ant-modal-body {
		padding: 0 24px 24px 24px;
		max-height: 70vh;
		overflow-y: auto;
	}

	.ant-modal-footer {
		border-top: none;
		padding: 0 24px 24px 24px;
		display: flex;
		justify-content: space-between;
	}

	.ant-modal-close {
		top: 16px;
		right: 16px;
	}

	.ant-modal-close-x {
		width: 32px;
		height: 32px;
		line-height: 32px;
		color: #9ca3af;

		&:hover {
			color: #6b7280;
		}
	}
`;

export const RemoveButton = styled(Button)`
	border-color: #ef4444;
	color: #ef4444;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	background: white;

	&:hover {
		background-color: #fef2f2;
		border-color: #dc2626;
		color: #dc2626;
	}
`;

export const SaveButton = styled(Button)`
	background-color: #1e3a8a;
	border-color: #1e3a8a;
	color: white;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;

	&:hover {
		background-color: #1e40af;
		border-color: #1e40af;
		color: white;
	}
`;

export const ModalFormItem = styled(Form.Item)`
	margin-bottom: 20px;

	.ant-form-item-label > label {
		font-size: 14px;
		color: #374151;
		font-weight: 500;

		&.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
			&::before {
				display: none !important;
			}

			&::after {
				display: inline-block;
				margin-left: 4px;
				color: #000000;
				font-size: 14px;
				font-family: SimSun, sans-serif;
				line-height: 1;
				content: '*';
			}
		}
	}

	.ant-input,
	.ant-select-selector {
		background-color: #f9fafb;
		border-color: #d1d5db;
		border-radius: 6px;
		height: 40px;
	}

	.ant-input:hover,
	.ant-select-selector:hover {
		border-color: #9ca3af;
		background-color: #f9fafb;
	}

	.ant-input:focus,
	.ant-select-focused .ant-select-selector {
		border-color: #6b7280;
		box-shadow: none;
		background-color: #f9fafb;
	}

	.ant-select-selection-placeholder {
		color: #9ca3af;
	}
`;
